/**
 * Formatea números al estilo argentino: punto para miles, coma para centavos
 * Ejemplo: 20000.50 -> "$20.000,50"
 */
export const formatCurrencyAR = (amount: number): string => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Formatea números sin símbolo de moneda al estilo argentino
 * Ejemplo: 20000.50 -> "20.000,50"
 */
export const formatNumberAR = (amount: number): string => {
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Formatea números sin decimales al estilo argentino
 * Ejemplo: 20000 -> "20.000"
 */
export const formatNumberARNoDecimals = (amount: number): string => {
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};
